import { PeValues, PeResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculatePe(values: PeValues, t?: ToolsTranslations['pe']): PeResult {
  const { pricePerShare, earningsPerShare } = values;

  if (pricePerShare <= 0) {
    return { 
      peRatio: null, 
      isValid: false, 
      message: t?.invalid.pricePerShare ?? 'Pris per aktie måste vara större än 0' 
    };
  }
  
  if (earningsPerShare <= 0) {
    return { 
      peRatio: null, 
      isValid: false, 
      message: t?.invalid.earningsPerShare ?? 'Vinst per aktie måste vara större än 0' 
    };
  }

  const peRatio = Math.round((pricePerShare / earningsPerShare) * 100) / 100; // Round to 2 decimal places

  if (!isFinite(peRatio)) {
    return { 
      peRatio: null, 
      isValid: false, 
      message: t?.invalid.generic ?? 'Ogiltiga värden' 
    };
  }

  // Determine interpretation
  let interpretation = '';
  if (peRatio < 10) {
    interpretation = t?.additionalInfo?.undervalued ?? 'Undervärderat (< 10x)';
  } else if (peRatio <= 20) {
    interpretation = t?.additionalInfo?.fairValue ?? 'Rättvärderat (10-20x)';
  } else {
    interpretation = t?.additionalInfo?.overvalued ?? 'Övervärderat (> 20x)';
  }

  return { 
    peRatio, 
    isValid: true, 
    interpretation 
  };
}
